import globalAxios from "axios";

export function createFileDownload(file: Blob, filename: string) {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
}

export function downloadBlob(
  url: string,
  filename: string,
  mimeType = "text/csv"
): Promise<void> {
  return globalAxios({ url, method: "GET", responseType: "blob" }).then(
    (response) => {
      if (!response.data) {
        throw new Error("Unable to download file");
      }
      const file = new Blob(
        [response.data],
        mimeType ? { type: mimeType } : undefined
      );

      createFileDownload(file, filename);
    }
  );
}
